import React from 'react'

import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Column, Text } from 'Components/UI'

import { StripedCircleSvg } from 'Assets/Svg'

import { useResponsiveLayout } from 'Hooks'

import { Content } from './styles'

function WelcomeSectionTitle() {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Column alignCenter fullWidth maxWidth="650px">
      <AppearingWrapper centered kind="expand">
        <Content>
          {StripedCircleSvg()}

          <Text
            accent
            as="h2"
            bold
            center
            screen24={!isDesktop}
            screen38={isDesktop}
          >
            Welcome to Emajin Golf
          </Text>
        </Content>
      </AppearingWrapper>

      <Text
        as="h3"
        bold
        center
        important
        mb={5}
        mt={3}
        screen18={!isDesktop}
        screen28={isDesktop}
      >
        Where golf, business & community combine.
      </Text>

      <Text body center screen14={!isDesktop} screen20={isDesktop}>
        Gain exclusive&nbsp;
        <Text as="span" bold screen14={!isDesktop} screen20={isDesktop} success>
          Access
        </Text>
        &nbsp;to Australia’s top golf courses,&nbsp;
        <Text as="span" bold screen14={!isDesktop} screen20={isDesktop} success>
          Learn
        </Text>
        &nbsp;from global leader presentations and&nbsp;
        <Text as="span" bold screen14={!isDesktop} screen20={isDesktop} success>
          Grow
        </Text>
        &nbsp;with our business community.
      </Text>
    </Column>
  )
}

export default WelcomeSectionTitle
